import React from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import styles from "./continue-to-option.css";

interface ContinueToOptionProps {
    href: string;
    continueMessage: string;
    analyticsEventLabel: string;
    isTrackedLink?: boolean;
    reason?: string;
    productId?: string;
    continueClick?: Function | null;
}

export default function ContinueToOption({
    href,
    continueMessage,
    analyticsEventLabel,
    isTrackedLink = false,
    reason,
    productId,
    continueClick,
}: ContinueToOptionProps): JSX.Element {
    function onClick(callbackFunction, event): void {
        const action = isTrackedLink ? "lead_click" : "continue_clicked";
        analytics.event("send_to_app", action, analyticsEventLabel);

        if (callbackFunction) {
            callbackFunction(event);
        }
        if (!href && continueClick) {
            continueClick();
        }
    }

    return (
        <>
            <div className={styles.orContainer}>
                <span className={styles.or}>{gettext("in_stock_product.or_separator")}</span>
            </div>
            {isTrackedLink ? (
                <LeadLink
                    href={href}
                    openInNewTab={true}
                    productId={productId}
                    reason={reason}
                    beforeOnClick={(callback, event): void => {
                        onClick(callback, event);
                    }}
                >
                    <span className={styles.continueMessage}>{continueMessage}</span>
                </LeadLink>
            ) : (
                <a
                    className={styles.continueLink}
                    href={href}
                    onClick={(event): void => {
                        onClick(null, event);
                    }}
                >
                    <span className={styles.continueMessage}>{continueMessage}</span>
                </a>
            )}
        </>
    );
}
